import React, { useCallback, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useMediaContext } from "../../../context/mediaQuery/MediaQueryContext";
import { QuoteTable, QuoteCardsList } from "./QuoteTable";
import { ButtonCurrencyBlock } from "./ButtonCurrencyBlock";

import useBonds from "../../../rq/queries/useBonds";
import { BondTypes } from "../../../types/bond_types";
import classNames from "classnames";
import { HocWithPreloader } from "../../../hocs/hocWithPreloader";
// import { ButtonBlock } from "../../../components/ButtonBlock/ButtonBlock";
// import { QueryCache } from 'react-query';

export const QuoteSection = ({ bondType = BondTypes.bond_type }) => {
  const { t } = useTranslation();

  const { isMatch } = useMediaContext();

  const { data = [], isLoading } = useBonds({ bondType });


  const [{ filtered, currency, currenciesList }, setState] = useState({
    filtered: [],
    currency: "",
    currenciesList: [],
  });

  useEffect(() => {
    if (!data.length) return;

    const filtered = {};
    for (const item of data) {
      const { currency_detail } = item;
      filtered[currency_detail]
        ? filtered[currency_detail].push(item)
        : (filtered[currency_detail] = [item]);
    }
    const currenciesList = Object.keys(filtered);

    setState({
      filtered: filtered[currenciesList[0]],
      currency: currenciesList[0],
      currenciesList,
    });
  }, [data]);


  // const [{ filtered, currency, currenciesList }, setState] = useState(() => {
  //   if (!data.length)
  //     return {
  //       filtered: [],
  //       currency: "",
  //       currenciesList: [],
  //     };

  //   const filtered = {};
  //   for (const item of data) {
  //     const { currency_detail } = item;
  //     filtered[currency_detail]
  //       ? filtered[currency_detail].push(item)
  //       : (filtered[currency_detail] = [item]);
  //   }
  //   const currenciesList = Object.keys(filtered);

  //   return {
  //     filtered: filtered[currenciesList[0]],
  //     currency: currenciesList[0],
  //     currenciesList,
  //   };
  // });

  // const { filtered, currency, currenciesList } = useMemo(() => {
  //   if (!data.length)
  //     return {
  //       filtered: [],
  //       currency: "",
  //       currenciesList: [],
  //     };

  //   const filtered = {};
  //   for (const item of data) {
  //     const { currency_detail } = item;
  //     filtered[currency_detail]
  //       ? filtered[currency_detail].push(item)
  //       : (filtered[currency_detail] = [item]);
  //   }
  //   const currenciesList = Object.keys(filtered);

  //   return {
  //     filtered: filtered[currenciesList[0]],
  //     currency: currenciesList[0],
  //     currenciesList,
  //   };
  // }, [data]);

  // useEffect(() => {
  //   if (!data.length) return;

  //   const filtered = {};
  //   for (const item of data) {
  //     const { currency_detail } = item;
  //     filtered[currency_detail]
  //       ? filtered[currency_detail].push(item)
  //       : (filtered[currency_detail] = [item]);
  //   }
  //   const currenciesList = Object.keys(filtered);

  //   setState({
  //     filtered: filtered[currenciesList[0]],
  //     currency: currenciesList[0],
  //     currenciesList,
  //   });
  // }, [data]);

  const handledFilterByCurrency = useCallback(
    ({ target }) => {
      const { value: currency } = target;

      const filtered = data.filter((i) => i.currency_detail === currency);
      setState((s) => ({ ...s, filtered, currency }));
    },
    [data]
  );

  const text = {
    [BondTypes.bond_type]: "quote_main_title",
    [BondTypes.eurobond_type]: "quote_main_eurobond_title",
    [BondTypes.corporate_type]: "quote_main_corporate_title",
    [BondTypes.share_type]: "quote_main_share_title",
  };

  const hasAnnualRate =
    bondType !== BondTypes.eurobond_type && bondType !== BondTypes.share_type;

  const hasQuotes = !!filtered?.length;
  return (
    <section className="section-quote section" id="_quote">
      <div className="container">
        {/* <ButtonBlock hash="quote" /> */}
        <div className="section-quote-inner">
          {/* <div className="attention-label">{t('quote_label')}</div> */}

          <div
            className={classNames("section-quote-content section-content", {
              "section-quote-content--full": !hasQuotes,
            })}
          >
            <HocWithPreloader isLoading={isLoading} data={data}>
              <>
                {hasQuotes ? (
                  <div className="section-label" data-label={t("quote_label")}>
                    <h3 className="section__title main-title">
                      {t(text[bondType])}
                    </h3>
                    <p className="title">{t("quote_main_text")}</p>
                  </div>
                ) : (
                  <div
                    className="section-label section-label--center"
                    data-label={t("quote_label")}
                  >
                    <p className="main-title">{t("quote_unavailable_title")}</p>
                  </div>
                )}

                <div className="quote-currency">
                  {currenciesList.length > 1 && (
                    <div className="quote-currency-filter">
                      <ButtonCurrencyBlock
                        onClick={handledFilterByCurrency}
                        title={currency}
                        items={currenciesList}
                      />
                    </div>
                  )}

                  {hasQuotes &&
                    (isMatch ? (
                      <QuoteTable
                        data={filtered}
                        hasAnnualRate={hasAnnualRate}
                      />
                    ) : (
                      <QuoteCardsList
                        data={filtered}
                        hasAnnualRate={hasAnnualRate}
                      />
                    ))}
                </div>
              </>
            </HocWithPreloader>
          </div>
        </div>
      </div>
    </section>
  );
};
